<template>
  <div class="container-fluid">
    <div class="row d-flex justify-content-center">
      <div class="w-100">
        <div class="hero-wrapper">
          <carousel :perPage="1" :paginationEnabled="false" :autoplay="true">
            <slide v-for="(image, index) in images" :key="index">
              <!-- <img :src="require(`@/assets/images/${image}`)" alt="image" /> -->
              <img :src="image" alt="image" />
            </slide>
          </carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { Carousel, Slide } from 'vue-carousel';


export default {

  name: 'HeroSlider',
  components: {
    Carousel,
    Slide
  },
  data() {
    return {
      images:''
    }
  },
  created() {
    this.images = this.$store.getters.getImages
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .VueCarousel-slide {
      img {
        width: 100%;
      }
    }

  // Small devices (landscape phones, 576px and up)
  @media (min-width: 576px) {

  }

  // Medium devices (tablets, 768px and up)
  @media (min-width: 768px) {

  }

  // Large devices (desktops, 992px and up)
  @media (min-width: 992px) {
    .hero-wrapper {
      height: 80vh;
      overflow: hidden;
    }

    .VueCarousel {
      margin-top: -25vh;
    }

  }

  // Extra large devices (large desktops, 1200px and up)
  @media (min-width: 1200px) {

  }
</style>
